import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { YHRightModal } from '@/components/YHRightModal'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { getFormValidatorErrText } from '@/utils/utils'
import { useDictModel } from '@/views/base/dict/dictModel'
import { Button, message, Tabs } from 'antd'
import React, { useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { IFollowUpOne, intentionService } from '../intentionService'
import styles from './FollowUpRecords.module.scss'

export const FollowUpRecords = ({ followUpRecordsVisible, setFollowUpRecordsVisible, franchiseeId }) => {
    const formRef = useRef<IYhFormRef>()
    const { getSelectedDictOne, getTreeNodeName } = useDictModel()

    const [activeKey, setActiveKey] = useState<string>('1')
    const onTabChange = (key: string) => {
        setActiveKey(key)
    }

    useEffect(() => {
        if (activeKey === '1' && followUpRecordsVisible) {
            getList()
        }
    }, [activeKey, followUpRecordsVisible])

    const [list, setList] = useState<IFollowUpOne[]>([])

    const getList = async () => {
        let { retData } = await intentionService.followOne(franchiseeId)
        setList(retData || [])
    }

    const baseFormItem: IYhFormItemsBox = {
        title: '客户跟进',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '跟进方式',
                fieldName: 'followUpMethod',
                options: getSelectedDictOne(DictCodeEnmu.FOLLOW_UP),
                span: 24,
                rules: [{ required: true, message: '请选择跟进方式' }],
            },
            // {
            //     type: FormItemTypeEnum.Datepicker,
            //     fieldLabel: '跟进时间',
            //     fieldName: 'createTime',
            //     span: 24,
            //     rules:  [{ required: true, message: '请选择跟进方式' }],
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '意向程度',
                fieldName: 'intentionLevel',
                options: getSelectedDictOne(DictCodeEnmu.INTENTION_LEVEL),
                span: 24,
                rules: [{ required: true, message: '请选择意向程度' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '跟进内容',
                fieldName: 'followUpContent',
                span: 24,
                rules: [{ required: true, message: '请输入跟进内容' }],
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '反馈意见',
                fieldName: 'feedback',
                span: 24,
                // rules: [{ required: true, message: '输入反馈意见' }],
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '跟进人员',
            //     fieldName: 'createUser',
            //     span: 24,
            //     rules:  [{ required: true, message: '请输入跟进人员' }],
            // },
        ],
    }

    const fromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: {},
        boxs: [baseFormItem],
    }

    const onsubmit = () => {
        formRef.current
            ?.validateFields()
            .then(async (val) => {
                let data = { franchiseeId, franchiseeCode: "", ...val }
                let { retData } = await intentionService.followInsert(data)
                message.success('新增跟进记录成功')
                formRef.current?.resetFields()
                setActiveKey('1')
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    return (
        <YHRightModal title="跟踪记录" width={600} visible={followUpRecordsVisible} onCancel={() => { setFollowUpRecordsVisible(false) }}>
            <Tabs activeKey={activeKey} onChange={onTabChange}>
                <Tabs.TabPane tab="跟踪记录" key="1">
                    <div style={{ height: "calc", overflowY: "scroll" }}>
                        {list.map((item) => (
                            <div className={styles['item']} key={item.id}>
                                <p className={styles['top']}>
                                    {item.createTime}<span className={styles['name']}>{item.franchiseeName}</span><span className={styles['intentionLevel']}>{item.intentionLevel && getTreeNodeName(item.intentionLevel)}</span>
                                </p>
                                <div className={styles['box']}>
                                    <p className={styles['font']}>
                                        <span className={styles['font-left']}>跟进方式</span><span className={styles['font-right']}>{item.followUpMethod && getTreeNodeName(item.followUpMethod)}</span>
                                    </p>
                                    <p className={styles['font']}>
                                        <span className={styles['font-left']}>跟进内容</span><span className={styles['font-right']}>{item.followUpContent}</span>
                                    </p>
                                    <p className={styles['font']}>
                                        <span className={styles['font-left']}>跟进人员</span><span className={styles['font-right']}>{item.createUser}</span>
                                    </p>
                                    <p className={styles['font']}>
                                        <span className={styles['font-left']}>反馈建议</span><span className={styles['font-right']}>{item.feedback}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                </Tabs.TabPane>
                <Tabs.TabPane tab="新增跟踪" key="2">
                    <YhFormBox {...fromConfig} />

                    <Button
                        shape="round"
                        onClick={() => {
                            onsubmit()
                        }}
                        type="primary"
                        style={{ float: 'right' }}
                    >
                        保存
                    </Button>
                    <Button
                        className="mr-5"
                        shape="round"
                        onClick={() => {
                            formRef.current?.resetFields()
                            setActiveKey('1')
                        }}
                        style={{ float: 'right' }}
                    >
                        取消
                    </Button>
                </Tabs.TabPane>
            </Tabs>
        </YHRightModal>
    )
}
